module.exports = __webpack_public_path__ + "static/one-percent-courtesy_bg_m-49fe399b1f52234d2d504895b1d2da40.jpg";